import {useEffect, useState} from 'react';
import * as React from 'react';
import {avannisReportsTheme} from '../../../shared/Charts/avannisReportsTheme';
import { CardComponent } from '../../../util/CardComponent';
import {userData} from '../../../util/userData';
import { PieChartComponent } from '../../SingleSurveyDashboardContainer/PieChartComponent';
import { useAppSelector } from '../hooks';
import { selectCommentMoods } from './commentMoodsSlice';

function updateCommentMoodFilter(chartPoint) {
  const filters = userData.getFilters();
  filters.mood = chartPoint.name;
  userData.updateFilters(filters, true);
}

export function CommentsMoodComponent() {
  const moods = useAppSelector(selectCommentMoods);
  const { isLoading } = moods;
  const { dataPoints, chartSubtitle } = moods;
  const [cardTitle, setCardTitle] = useState(
    'Sentiment Type (% total statements)'
  );

  useEffect(() => {
    setCardTitle(isLoading ? 'Sentiment Type (% total statements)' : '');
  }, [isLoading]);

  return (
    <CardComponent title={cardTitle} isLoading={isLoading}>
      <PieChartComponent
        title={'Sentiment Type (% total statements)'}
        isLoading={false}
        legend={false}
        series={[]}
        categories={['series1', 'series2', 'series3']}
        factor={'100'}
        seriesName={'series'}
        avannisAvg={20}
        htmlSubtitle={chartSubtitle}
        dataPoints={dataPoints}
        noDataMessage={''}
        clickHandler={(chartPoint) => {
          updateCommentMoodFilter(chartPoint);
        }}
        highChartsTheme={avannisReportsTheme}
      />
    </CardComponent>
  );
}
